import { render } from 'outpost/preact';
import { App } from './components/app.tsx';

async function main() {
    setTimeout(() => render( <App/>, document.body));
}

main();